<template>
  <div class="home">

    <div class="content">

      <section class="clearfix">
        <h2 id="title">{{dynamicTitle('title')}}</h2>

        <router-link v-if="$parent.isPhone" id="createOrderButtonMobile" v-bind:to="{ name: 'CreateOrder'}"><i class="icon-plus"></i></router-link>
        <router-link v-else id="createOrderButton" v-bind:to="{ name: 'CreateOrder'}"><i class="icon-plus"></i>{{dynamicTitle('createOrder')}}</router-link>

      </section>

      <section v-if="$parent.isPhone" class="mobilelist">
        <div>

          <ul v-for="order in orders" v-bind:key="order.id">
            <li class="order_row_mobile" v-bind:id="'row_mobile_' + order.id" 
                v-on:touchstart="isTouchScreen ? mouseDown($event, order) : null" 
                v-on:mousedown="isTouchScreen == false ? mouseDown($event, order) : null" 
                @click="rowClicked(order)">
              <div>
                <div class="order_row_mobile_name center_content">
                    <span class="btn_link_copy" @click.stop="copyURL(order)"> 
                      <!-- URLコピーしたアイコン -->
                      <img class="mobile_img_copy_icon" src="../assets/mobile_url_copy_selected.png" alt="url_link" v-if="order.copied == true"/> 
                      <!-- URLコピーするアイコン -->
                      <img class="mobile_img_copy_icon" src="../assets/mobile_url_copy.png" alt="url_link" v-else/> 
                    </span>
                    {{ order.data().name }} / {{order.data().client}}
                </div>
                <div class="order_row_mobile_address" v-if="order.data().destination_address != null">
                  {{ order.data().destination_address }}
                </div>
                <div class="order_row_mobile_separator"></div>
                <div v-bind:class="{'order_row_mobile_driver': order.data().driver_id != null, 'order_row_mobile_driver_blank':  order.data().driver_id == null}">
                  {{getDriverName(order.data().driver_id)}}<span v-if="order.data().status === 'started'"> ({{dynamicTitle('delivering')}})</span>
                </div>
                <!-- {{ orderCreatedDatetime(order.data())}} を表示しなくてよいか？ -->
              </div>
            </li>
          </ul>
        </div>
      </section>

      <table v-else>
        <colgroup>
          <col v-bind:class="{'col_1_ds': company != null && company.type === 'dayservice', 'col_1':  company != null && company.type !== 'dayservice'}"/>
          <col v-bind:class="{'col_2_ds': company != null && company.type === 'dayservice', 'col_2':  company != null && company.type !== 'dayservice'}" />
          <col v-bind:class="{'col_3_ds': company != null && company.type === 'dayservice', 'col_3':  company != null && company.type !== 'dayservice'}" />

          <!-- デイサービスのときは非表示 -->
          <col v-bind:class="{'col_4_ds': company != null && company.type === 'dayservice', 'col_4':  company != null && company.type !== 'dayservice'}" v-if="company != null && company.type === 'dayservice'" />
          <col v-bind:class="{'col_5_ds': company != null && company.type === 'dayservice', 'col_5':  company != null && company.type !== 'dayservice'}" v-if="company != null && company.type === 'dayservice'" />
        </colgroup>

        <thead>

        <tr>
          <!-- デイサービスのときは非表示 -->
          <th v-if="company != null && company.type !== 'dayservice'">{{dynamicTitle('clientNameTitle')}}</th>
          <th v-if="company != null && company.type !== 'dayservice'">{{dynamicTitle('orderCreatedDate')}}</th>

          <th>{{dynamicTitle('orderNameTitle')}}</th>
          <th>{{dynamicTitle('destination')}}</th>

          <th>ドライバー</th>

        </tr>
        </thead>

        <tbody v-if="orders">
        <tr class="orderRow" v-bind:class="{'orderRowStarted': order.data().status === 'started', 'orderRowNotStarted': order.data().status !== 'started'}" v-for="order in orders" v-bind:key="order.id" @click="rowClicked(order)">
          <td>
            {{order.data().client}}
          </td>

          <!-- デイサービスのときは非表示 -->
          <td v-if="company != null && company.type !== 'dayservice'">{{ orderCreatedDatetime(order.data())}}</td>
          <td v-if="company != null && company.type !== 'dayservice'">{{ order.data().name }}</td>

          <td>
            <div v-if="order.data().destination_address != null">
              {{ order.data().destination_address }}
            </div>
          </td>
          <!--<td>{{drivers[order['id']]}}</td>-->
          <td>{{getDriverName(order.data().driver_id)}}<span v-if="order.data().status === 'started'"> ({{dynamicTitle('delivering')}})</span></td>

          <td class="td_link_copy" @click.stop="copyURL(order)">
             <!-- URLコピーしたアイコン -->
            <div class="center_content green_border" v-if="order.copied == true">
              <span class="btn_link_copy"><img class="img_copy_icon" src="../assets/url_copy_selected.png" alt="url_link"/>コピーしました</span>
            </div>
             <!-- URLコピーするアイコン -->
            <div class="center_content no_border" v-else>
              <span class="btn_link_copy"><img class="img_copy_icon" src="../assets/url_copy.png" alt="url_link"/>リンクをコピー</span>
            </div>
          </td>
          
          <!--
          <td>
            <router-link v-bind:to="{ name: 'OrderDetail', params: { id: order['id'] }}">詳細</router-link>
          </td>
          -->
        </tr>
        </tbody>
        <tfoot>
        <!--
        <td colspan="1" align="left">
          <strong>Total Number:</strong>
        </td>
        <td>{{ orders.length }}</td>
        -->
        </tfoot>
      </table>


      <div class="pagination_controller">

        <img class="pagination_arrow_right" :src="rightArrowSrc" alt="Right Arrow" @click="loadNextOrders">


        <img class="pagination_arrow_left" :src="leftArrowSrc" alt="Left Arrow" @click="loadPreviousOrders">



        <div class="pagination_info">
          <span>{{paginationInfo}}</span>
        </div>

      </div>

    </div>
  </div>

</template>

<script>
  import {db, auth} from '../firebase'
  import moment from 'moment'
  import VueClipboard from 'vue-clipboard2'


  const words = {
    'dayservice' : {
      'title' : '送迎一覧',
      'createOrder' : '送迎先を新規登録',
      'clientNameTitle' : 'ご契約者様',
      'orderCreatedDate' : '送迎作成日時',
      'orderNameTitle' : 'ご利用者様',
      'destination' : '送迎先',
      'delivering' : '送迎中'
    },
    'bike' : {
      'title' : '注文一覧',
      'createOrder' : '注文を新規登録',
      'clientNameTitle' : 'ご依頼主',
      'orderCreatedDate' : '注文作成日時',
      'orderNameTitle' : '品物',
      'destination' : '配達先',
      'delivering' : '配達中'
    },
    'default' : {
      'title' : '一覧',
      'createOrder' : '新規登録',
      'clientNameTitle' : 'ご契約者様',
      'orderCreatedDate' : '作成日時',
      'orderNameTitle' : '送り届け中の方、または配達物',
      'destination' : '向かい先',
      'delivering' : '向かい中'
    }
  }

  export default {
    name: 'Home',

    computed: {

      paginationInfo (){
        let idx = this.currentPage - 1
        let from = idx * this.perPage + 1
        let to = from + this.orders.length - 1
        return `${from} -  ${to}`
      },

      leftArrowSrc() {
        if(this.isFirstOrderShown) {
          return require("@/assets/arrow_left_inactive@2x.png")
        }else{
          return require("@/assets/arrow_left_active@2x.png")
        }

      },

      rightArrowSrc() {
        if(this.isLastOrderShown){
          return require("@/assets/arrow_right_inactive@2x.png")
        }else{
          return require("@/assets/arrow_right_active@2x.png")
        }

      },

      /*
      position: function () {
        self = this;
        return function (order) {
          let tracking = order['tracking']

            if(tracking != null){
              let position = tracking['position']
              if(position != null){
                return position.latitude + ", " +  position.longitude
              }
            }
          return "";
        };
      },
      */

      trackingDatetime: function () {
        self = this;
        return function (order) {
          let tracking = order['tracking']
          if(tracking != null){
            let date = tracking['datetime'].toDate()
            return moment(date).format('YYYY/MM/DD HH:mm')
          }
          return ""
        };
      },

      orderCreatedDatetime: function () {
        self = this;
        return function (order) {
          let createdAt = order['createdAt']
          if(createdAt != null){
            let date = createdAt.toDate()
            return moment(date).format('YYYY/MM/DD HH:mm')
          }
          return ""
        };
      },

      companyId() {
        let coId = this.$store.getters.companyId
        if(coId){
          return coId
        }

        //localStorageに存在したらそれをVuexのstoreに書き込んでリターンする。
        if (localStorage.companyId) {
          this.$store.commit('setCompanyId', localStorage.companyId)
          return localStorage.companyId
        }
      },
      
      // returns true if mobile phone with touchscreen
      isTouchScreen: function () {
        let touchDevice = ('ontouchstart' in document.documentElement);
        return touchDevice 
      }

      /*
      datetime() {
        return order => order['tracking']['datetime'].toDate() | moment
      }
      */


    },

    data () {
      return {
        orders: [],
        drivers: [],

        perPage: 50,
        currentPage: 1, //最初のページは1 (0ではない)

        isFirstOrderShown: true,
        isLastOrderShown: false,

        company: null
      }
    },

    methods: {

      //これはdocの配列がとれない（dataの配列になってしまう）ので今は使っていない。
      getOrders () {
        let self = this
        this.$bind('orders', db.collection('companies').doc(this.companyId).collection('orders').orderBy("createdAt", "desc").limit(this.perPage)).then(orders => {
          //this.getDrivers(orders, self)
          console.log("getOrders done", orders)
          this.lastVisibleOrder = orders[orders.length-1]
        })
      },


      async fetchNextOrders() {
        try {
          let querySnapshot
          if(this.orders.length > 0){
            querySnapshot = await db.collection('companies').doc(this.companyId).collection('orders').orderBy("createdAt", "desc").startAfter(this.orders[this.orders.length - 1]).limit(this.perPage).get()
          }else{
            querySnapshot = await db.collection('companies').doc(this.companyId).collection('orders').orderBy("createdAt", "desc").limit(this.perPage).get()
          }

          if(querySnapshot.size > 0){
            console.log("querySnapshot", querySnapshot);
            if(this.orders.length === 0){
              this.isFirstOrderShown = true
              this.currentPage = 1
            }else{
              this.isFirstOrderShown = false
              this.currentPage++
            }
            this.orders = querySnapshot.docs

            if(this.orders.length < this.perPage){
              this.isLastOrderShown = true
            }
          }else{
            console.log("No such order");
            this.isLastOrderShown = true
          }
        }catch(error){
          console.log("Error while fetching next orders", error);
        }
      },


      async fetchPreviousOrders() {
        //これを参考にした
        //https://stackoverflow.com/a/54075453/1709287
        try {
          if(this.orders.length > 0){

            //sortOrderを逆さまにすることで、今一番まえのものより、perPageだけ前にいる要素をstartAfterで取り出せる。
            let querySnapshot = await db.collection('companies').doc(this.companyId).collection('orders').orderBy("createdAt", "asc").startAfter(this.orders[0]).limit(this.perPage).get()

            if(querySnapshot.size > 0){
              console.log("querySnapshot", querySnapshot);

              //sort order = ascになっていて、逆順になっているので、reverse()してdesc順に戻す
              this.orders = querySnapshot.docs.reverse()

              this.isLastOrderShown = false
              this.currentPage--

              if(this.currentPage === 1){
                this.isFirstOrderShown = true
              }
            }else{
              console.log("No such order");
              this.isFirstOrderShown = true
            }
          }
        }catch(error){
          console.log("Error while fetching previous orders", error);
        }
      },

      getDrivers () {
        let self = this

        this.$bind('drivers', db.collection('companies').doc(this.companyId).collection('drivers')).then(drivers => {
          //this.getDrivers(orders, self)
        })
      },

      getCompany () {
        let self = this

        /*
        this.$bind('company', db.collection('companies').doc(this.companyId)).then(company => {
          //this.getDrivers(orders, self)
        })
        */

        this.$bind('company', db.collection('companies').doc(this.companyId)).then(company => {
          this.$unbind('company')
        })

        /*
        db.collection('companies').doc(this.companyId).get().then((doc) => {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            this.companyType = doc.data().type
          }
        })
        */
      },

      getDriverName(driverId) {
        if(driverId == null){
          //console.log('driverId null')
          return null
        }else{
          //console.log('driverId', driverId)
          let chosenDriver = this.drivers.find(driver => driver.id === driverId)
          if(chosenDriver != null){
            return chosenDriver.name
          }else{
            return null
          }
        }

      },


      rowClicked(orderDoc) {
        console.log('order pushed', orderDoc.id)
        this.$router.push({ name: 'OrderDetail', params: { id: orderDoc['id'] }})

      },

      /**
       * Mobile view ONLY
       * ・カードの中 (「リンクコピー」 ボタン以外) はクリックされた時にgreen borderを付ける
       */
      mouseDown(element, order) {
        function not_copy_link(){
          return (element.srcElement.nodeName != 'IMG' && element.srcElement.className != 'btn_link_copy') 
        }
        const card = document.getElementById('row_mobile_'+order.id)
        if(not_copy_link()){
          card.classList.add('order_row_mobile_body_only');
        }
      },

      loadNextOrders() {
        //this.updateOrders()
        this.fetchNextOrders()
      },

      loadPreviousOrders() {
        this.fetchPreviousOrders()

      },

      /* ダイナミックタイトル */
      dynamicTitle(key){
        if(this.company){
          let type = this.company.type
          let wordSet = words[type]
          if(!wordSet){
            wordSet = words['default']
          }
          return wordSet[key]
        }
        return words['default'][key]
      },

      /**
       * リンクコピー機能 (path: '/u/:company_id/o/:id')
       */
      copyURL: function(chosen_order){
        let item_url = window.location.host + "/u/" + this.companyId + "/o/" + chosen_order.id
        let obj = this.orders

        this.$copyText(item_url).then(function (e) {
          Object.keys(obj).forEach(function(k) {
            obj[k].id == chosen_order.id ? obj[k]['copied'] = true : obj[k]['copied'] = false
          });
        }, function (e) {
          console.log("error details: ", e)
        })
        this.$forceUpdate()
      },

    },




    /*
    firestore: {
      drivers: db.collection('companies').doc(this.companyId).collection('drivers')
    },
    */



    filters: {
      moment: function (date) {
        return moment(date).format('YYYY/MM/DD HH:mm');
      }
    },

    mounted () {

      if(!this.companyId){
        this.$router.push('/signin')
      }else{


        //this.getOrders()

        this.fetchNextOrders()
        this.getDrivers()
        //this.getCompany()
        /*


       */
      }
    }
  }
</script>

<style scoped>



  .home {
    width: 100%;
    height: 100vh;
    background-color: #F3F3F3;

  }

  .content {
    width: 84%;
    margin-left:auto;
    margin-right:auto;
    padding-bottom: 80px;
  }


  .clearfix:after {
    content: "";
    display: block;
    clear: both;

  }

  #title {
    float: left;
    margin: 63px 0 0 0;
    color: #5C5C5C;
    font-weight: normal;
    font-size: 30px;
  }

  #createOrderButton {
    float: right;
    margin: 53px 0 0 0;
    background-color: #D2FF00;
    color: #5C5C5C;
    border-radius: 11px;
    text-decoration: none;
    padding: 3px 43px 2px 43px;
    font-size: 20px;
    font-weight: normal;

    border-style: solid;
    border-color: Transparent;
    border-width: 2px;
  }

  #createOrderButton i{
    margin-right: 10px;
    width: 25px;
    height: 25px;
  }

  #createOrderButton:hover {
    border-style: solid;
    border-width: 2px;
    border-color: #C7D931;
  }





  /* tbodyの外側に枠を引く
  https://stackoverflow.com/a/18990202/1709287
  */
  table{
    width: 100%;
    margin-top: 39px;
    height: 100%; /* needed to maximize .center_content height */ 
    border-collapse: collapse;
  }

  tbody {
    border: 3px solid #D2D2D2;
    border-collapse: separate;
    border-spacing: 4px;
    background-color: white;
  }

  /* 各業の下に線を引く
  https://stackoverflow.com/a/10040976/1709287
  */

  .col_1 {
    width: 11%;
  }

  .col_2 {
    width: 19%;
  }

  .col_3 {
    width: 16%;
  }

  .col_4 {
    width: 42%;
  }

  .col_5 {
    width: 11%;
  }


  /* デイサービス用のカラム幅設定*/
  .col_1_ds {
    width: 20%;
  }

  .col_2_ds {
    width: 60%;
  }

  .col_3_ds {
    width: 20%;
  }

  .col_4_ds {
    width: 0%;
  }

  .col_5_ds {
    width: 0%;
  }



  tr.orderRow td:not(.td_link_copy) { /* not(.td_link_copy) is used to maximize .center_content height */ 
    border-bottom: 3px solid #D2D2D2;
    color: #5C5C5C;
    font-weight: lighter;
    font-size: 17px;
    padding: 11px 18px 10px 16px;
  }

  th {
    text-align:left;
    color: #5C5C5C;
    font-weight: normal;
    font-size: 20px;

  }

  tr.orderRow td span:not(.btn_link_copy){  /* :not(.btn_link_copy) is used to override the span attributes with btn_link_copy */ 
    color: #5C5C5C;
    font-weight: lighter;
    font-size: 17px;
  }


  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  .orderRow:hover {background-color: #F2F2F2;}

  .orderRowStarted {
    background-color: #E8FF7F;
  }

  .pagination_controller {
    margin-top: 20px;
  }

  .pagination_arrow_left {
    float: right;
     width: 10px;
     padding: 10px 10px 10px 10px;
     margin: 0 20px 0 0;
   }

  /* start of 「リンクコピー」 */
  .td_link_copy{
    border: 3px solid #D2D2D2;
    height: 100%;
    color: #5C5C5C; 
    cursor: pointer;
  }

  .td_link_copy div{
    justify-content: center;
    cursor: pointer;
  }

  .center_content {
    height: 100%; 
    display: flex;
    align-items: center;
  }

  .green_border {
    border: 3px solid #E8FF7F;
  }

  .no_border {
    border: 3px solid Transparent;
  }

  span.btn_link_copy{
    border: none;
    font-size: 13px; 
    display: inline;
    cursor: pointer;
  }  

  
  .img_copy_icon {          /* web view */
     width: 21px;
     height: 23px;
     margin-right: 1px;
  }

  .mobile_img_copy_icon {   /* mobile view */
     width: 36px;
     margin-right: 5px;
  }

  /* end of 「リンクコピー」 */

  .pagination_arrow_right {
    float: right;
    width: 10px;
    padding: 10px 10px 10px 10px;
    margin: 0 0 0 20px;
  }

  .pagination_info{
    float: right;
    margin-right: 20px;

  }

  .pagination_info span{
    color: #5C5C5C;
    font-size: 18px;
  }


  /* モバイル時の行 */
  .order_row_mobile {
    width: 100%;
    background-color: white;
    border: 1px solid #D2D2D2;
    color: #5C5C5C;
    font-weight: lighter;
    font-size: 17px;
    margin: 0 0 5px 0;
  }

  .order_row_mobile:hover{
    background-color: #e6e3e3;
  }
  
  .order_row_mobile_body_only:active { /* カードの中 (「リンクコピー」 ボタン以外) はクリックされた時にgreen borderを付ける*/
    border: 1px solid #D2FF00;
    background: #e6e3e3;
  }

  .order_row_mobile_name {
    margin: 16px 13px 0 13px;
    font-size: 17px;
    justify-content: left;
  }

  .order_row_mobile_address {
    margin: 13px 13px 10px 13px;
    font-size: 15px;
  }

  .order_row_mobile_separator{
    background-color: #D2D2D2;
    height: 1px;
  }

  .order_row_mobile_driver {
    margin: 8px 12px 8px 12px;
    text-align: right;
    font-size: 15px;
  }

  .order_row_mobile_driver_blank {
    margin: 0 12px 0 12px;
    height: 32px;
  }


  #createOrderButtonMobile {
    float: right;
    margin: 18px 0 0 0;
    background-color: #D2FF00;
    color: #5C5C5C;
    border-radius: 11px;
    text-decoration: none;
    padding: 0 12px 0 12px;
    font-size: 20px;
    font-weight: normal;

    border-style: solid;
    border-color: Transparent;
    border-width: 2px;
  }


  #createOrderButtonMobile i{
    width: 25px;
    height: 25px;
    margin: 0 0 0 0;
  }


  .mobilelist {
    margin-top: 20px;
  }



  /*mobile対応(iPad含む)*/
  @media(max-width: 768px) {
    tr.orderRow td {
      font-size: 13px;
    }

    th {
      font-size: 16px;
    }


    tr.orderRow td span{
      font-size: 13px;
    }

  }


  /*mobile対応(iPadを除外)*/
  @media(max-width: 767px) {
    #title {
      float: left;
      margin: 25px 0 0 0;
      color: #5C5C5C;
      font-weight: bold;
      font-size: 21px;
    }



  }


</style>



// WEBPACK FOOTER //
// src/pages/Home.vue